<template>
    <div class="bng-jackpot-win">
        <confetti ref="confetti" />
        <transition name="jackpot-win-show">
            <div v-if="winningJackpot" class="jackpot-win">
                <div class="modal-jackpot">
                    <div class="modal-inner">
                        <div class="label">{{"components.common.jackpots.jackpot-win.jackpot won" | translate}}</div>
                        <div
                            class="amount"
                        >{{winningJackpot.amount | currency(winningJackpot.currency)}}</div>
                        <div>
                            <a
                                class="button is-large is-danger"
                                @click="take()"
                                :disabled="loading"
                                :class="{'is-loading': loading}"
                            >{{"components.common.jackpots.jackpot-win.take jackpot" | translate}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import Vue from 'vue';

import jackpotService from '../../../../../../_common/services/jackpot.service';

import Confetti from '../../../../../../_common/components/confetti.vue';

export default {
    name: 'jackpot-win',
    components: { Confetti },
    data() {
        return {
            loading: false
        };
    },
    computed: {
        player() {
            return Vue.state.player.get();
        },
        winningJackpot() {
            let jp = this.player && this.player.winningJackpot;
            if (jp && this.$refs.confetti && !this.$refs.confetti.active) {
                this.$refs.confetti.start();
            }
            if (!jp && this.$refs.confetti && this.$refs.confetti.active) {
                this.$refs.confetti.stop();
            }
            return jp;
        }
    },
    methods: {
        async take() {
            this.loading = true;
            await jackpotService.take(this.winningJackpot.id);
            Vue.state.player.unsetWinningJackpot();
            this.loading = false;
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/jackpots/jackpot-win/jackpot-win.vue